"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileTypeToFileExtension = exports.documentTemplateToFileType = void 0;
const file_ts_1 = require("@mothership/file-ts");
const models_1 = require("../models");
const documentTemplateToFileType = (documentTemplate) => {
    switch (documentTemplate) {
        case models_1.DocumentTemplate.XPODeliveryReceipt:
            return file_ts_1.FileType.DELIVERY_RECEIPT;
        case models_1.DocumentTemplate.RateConfirmation:
            return file_ts_1.FileType.SHIPMENT_DOCUMENT;
        case models_1.DocumentTemplate.CarrierEarningsReport:
            return file_ts_1.FileType.CARRIER_EARNINGS;
        default:
            return file_ts_1.FileType.UNKNOWN;
    }
};
exports.documentTemplateToFileType = documentTemplateToFileType;
const fileTypeToFileExtension = (fileType) => {
    switch (fileType) {
        case models_1.FileType.Pdf:
            return file_ts_1.FileExtension.PDF;
        case models_1.FileType.Csv:
        case models_1.FileType.Netsuite:
        case models_1.FileType.Quickbooks:
        case models_1.FileType.Xero:
            return file_ts_1.FileExtension.CSV;
        default:
            return file_ts_1.FileExtension.PDF;
    }
};
exports.fileTypeToFileExtension = fileTypeToFileExtension;
//# sourceMappingURL=document.js.map